export interface Contact {
  id: number;
  fullName: string;
  email: string;
  phoneNumber: string;
  subject: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  archivedAt?: string; // Add this field
  isArchived: boolean; // Add this field
}

export interface CustomerContact {
  id: number;
  subject: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  // Archived contacts are hidden from customers, so no need for archive fields here
}

export interface ContactCreate {
  fullName: string;
  email: string;
  phoneNumber?: string;
  subject?: string;
  message: string;
}

export interface ContactForm {
  fullName: string;
  email: string;
  phoneNumber?: string;
  subject?: string;
  message: string;
}

// Validation patterns
export const ValidationPatterns = {
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phone: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  name: /^[a-zA-ZÀ-ÿ\s'-]{2,50}$/
} as const;

export interface ContactSearchCriteria {
  search?: string;
  isRead?: boolean;
  email?: string;
  isArchived?: boolean; // Add this field
}

export interface Pageable {
  page: number;
  size: number;
  sort: string;
  direction: 'ASC' | 'DESC';
}